$bog_techradar_app $mol_page
	title \Tech Radar — $mol Stack
	plugins /
		<= Theme $bog_theme_auto
			theme_light \$mol_theme_calm_light
			theme_dark \$mol_theme_calm_dark
			themes /
				\$mol_theme_calm_light
				\$mol_theme_calm_dark
	tools /
		<= Lights $bog_theme_toggle
			theme_auto <= Theme
	body /
		<= Header $mol_view
			sub /
				<= Header_title $mol_view sub /
					\Tech Radar — $mol Stack
				<= Header_date $mol_view sub /
					<= header_date_text \2026.06
		<= Info $mol_view
			sub /
				<= Info_intro $mol_view sub /
					\От центра к периферии радара идут четыре круга:
				<= Info_adopt $mol_view sub /
					\Adopt — технологии и инструменты, которые внедрены и активно используются в командах. Технологии, по которым в X5Tech есть экспертиза.
				<= Info_trial $mol_view sub /
					\Trial — технологии и инструменты, которые уже прошли этап тестирования и готовятся к работе в продакшн (или уже работают там).
				<= Info_assess $mol_view sub /
					\Assess — пробные технологии и инструменты, которые сейчас оцениваются. С их участием реализуются только тестовые проекты, в реальных задачах они не используются.
				<= Info_hold $mol_view sub /
					\Hold — в этой категории есть экспертиза, но инструменты используются только при поддержке существующих систем — новые проекты на них не запускаются.
				<= Info_source $mol_view sub /
					\За основу взят Tech Radar Zalando. Похожие есть у ThoughtWorks. В России концепцию используют, например, Avito и Lamoda.
		<= Layout $mol_view
			sub /
				<= Q_block_techniques $mol_view
					sub /
						<= Q_block_techniques_title $mol_view sub /
							\Techniques
						<= Q_block_techniques_list $mol_view sub <= q_block_techniques_items /
				<= Q_block_tools $mol_view
					sub /
						<= Q_block_tools_title $mol_view sub /
							\Tools & Environment
						<= Q_block_tools_list $mol_view sub <= q_block_tools_items /
				<= Q_block_libraries $mol_view
					sub /
						<= Q_block_libraries_title $mol_view sub /
							\Libraries
						<= Q_block_libraries_list $mol_view sub <= q_block_libraries_items /
				<= Q_block_languages $mol_view
					sub /
						<= Q_block_languages_title $mol_view sub /
							\Languages & Frameworks
						<= Q_block_languages_list $mol_view sub <= q_block_languages_items /
				<= Radar_box $mol_view
					sub /
						<= Radar $mol_svg_root
							view_box \-700 -500 1400 1000
							event *
								^
								mouseleave? <=> radar_leave?event null
							sub <= radar_items /
						<= Pops $mol_view
							sub <= blip_pops /
		<= Forms_legend $mol_view
			sub /
				\▲ moved up    ▼ moved down    ★ new    ⬤ no change
	Ring* $mol_svg_circle
		pos_x \0
		pos_y \0
		radius <= ring_radius* \0
		attr *
			^
			fill \none
			stroke \#bbb
			stroke-width \1
	Axis* $mol_svg_line
		from_x <= axis_from_x* \0
		from_y <= axis_from_y* \0
		to_x <= axis_to_x* \0
		to_y <= axis_to_y* \0
		attr *
			^
			stroke \#bbb
			stroke-width \1
	R_big_label* $mol_svg_text
		pos_x \0
		pos_y <= r_big_label_y* \0
		text <= r_big_label_text* \
		attr *
			^
			fill <= r_big_label_color* \#5ba300
			font-size \42
			font-weight \bold
			text-anchor \middle
			opacity <= r_big_label_opacity* \0.25
	Blip* $mol_svg_group
		sub /
			<= Blip_shape* $mol_svg_path
				geometry <= blip_shape_d* \
				attr *
					^
					fill <= blip_color* \#5ba300
			<= Blip_num* $mol_svg_text
				pos_x <= blip_x* \0
				pos_y <= blip_num_y* \0
				text <= blip_num* \
				attr *
					^
					fill \#fff
					font-size \11
					font-weight \bold
					text-anchor \middle
					pointer-events \none
	Blip_pop* $mol_pop_over
		align \top_center
		event *
			^
			click? <=> blip_pop_click*?event null
		bubble_content /
			<= blip_label* \
	R_header* $mol_view
		sub /
			<= r_header_text* \
	Blip_row* $mol_link
		uri <= blip_row_uri* \
		external true
		title <= blip_row_text* \
	Blip_text* $mol_view
		sub /
			<= blip_row_text* \
